/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createDeck = /* GraphQL */ `mutation CreateDeck($userAlias: String!, $request: CreateDeckInput!) {
  createDeck(userAlias: $userAlias, request: $request) {
    pk
    sk
    deckGSI_pk
    deckGSI_sk
    deck_name
    created_date
    last_updated_date
    created_by
    last_updated_by
    current_user
    locked_by
    locked_at
    lock_expiry
    publish_status
    publish_user
    publish_deck_cycle
    has_active_system_run
    last_publish_date
    publish_timestamp
    deck_cycle
    enabled_page_grains
    enabled_datasets
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDeckMutationVariables,
  APITypes.CreateDeckMutation
>;
export const createTOCEntry = /* GraphQL */ `mutation CreateTOCEntry($userAlias: String!, $request: CreateTOCEntryInput!) {
  createTOCEntry(userAlias: $userAlias, request: $request) {
    pk
    sk
    toc_id
    page_id
    page_no
    toc_page_name
    page_name
    is_visible
    is_active
    group_name
    serial_no
    created_date
    last_updated_date
    schedule_type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTOCEntryMutationVariables,
  APITypes.CreateTOCEntryMutation
>;
export const createScenarioManagementEntry = /* GraphQL */ `mutation CreateScenarioManagementEntry(
  $userAlias: String!
  $request: CreateScenarioManagementEntryInput!
) {
  createScenarioManagementEntry(userAlias: $userAlias, request: $request) {
    pk
    sk
    scenario_id
    deck_cycle
    month
    page_name
    page_no
    sno
    is_external_page
    page_grain
    schedule_type
    last_updated_date
    is_supplemental
    is_blankpage
    toc_sno
    toc_page_no
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScenarioManagementEntryMutationVariables,
  APITypes.CreateScenarioManagementEntryMutation
>;
export const createPage = /* GraphQL */ `mutation CreatePage($userAlias: String!, $request: CreatePageInput!) {
  createPage(userAlias: $userAlias, request: $request) {
    pk
    sk
    pageGSI_pk
    pageGSI_sk
    page_name
    deck_id
    page_grain
    page_no
    page_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    previous_page_id
    next_page_id
    page_type
    denominator_label
    scale
    locked_by
    locked_at
    lock_expiry
    layout_family
    report_header
    __typename
  }
}` as GeneratedMutation<
  APITypes.CreatePageMutationVariables,
  APITypes.CreatePageMutation
>;
export const createDeckline = /* GraphQL */ `mutation CreateDeckline($userAlias: String!, $request: CreateDecklineInput!) {
  createDeckline(userAlias: $userAlias, request: $request) {
    calc_members {
      dimension
      tokens {
        kind
        value
        __typename
      }
      pins {
        dimension
        node
        __typename
      }
      __typename
    }
    pk
    sk
    page_name
    kpi_id
    kpi_id_by_override {
      override_set {
        datasetSource
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        fieldtype
        __typename
      }
      kpi_id
      __typename
    }
    kpi_name
    kpi_formula
    serial_no
    is_code_or_description
    is_format_bold
    is_format_italics
    is_format_underline
    format_text_color
    format_cell_color
    format_cell_default
    format_cell_overrides {
      colKey
      format
      __typename
    }
    blankline_type
    is_format_borderline
    footnotes
    subtotal_formula
    subtotal_parent
    is_calculated_kpi
    kpi_type
    deckline_kind
    deckline_drivers {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    is_exception
    page_section
    column_template
    adjcalcflag
    exceptioncalculatedkpiflag
    bordertopflag
    borderrightflag
    borderbottomflag
    borderleftflag
    borderweightflag
    textunderlineflag
    denominator_kpi_id_for_pct
    denominator_kpi_id_drivers {
      datasetSource
      account_hierarchy
      account
      location_hierarchy
      location
      project_hierarchy
      project
      company_hierarchy
      company
      product_hierarchy
      product
      revgp_hierarchy
      revgp
      datasource_hierarchy
      datasource
      channel_hierarchy
      channel
      costcenter_hierarchy
      costcenter
      costtype
      costpool
      fieldtype
      __typename
    }
    denominator_is_calculated_kpi
    denominator_kpi_formula
    root_kpi_id
    kpi_variant_id
    display_name
    denominator_kpi_variant_id
    measure
    kpi_name_indent_level
    fxinclflag
    calcdivisionflag
    bps_override_flag
    comments {
      commentId
      user
      commentDesc
      timestamp
      __typename
    }
    __typename
  }
}` as GeneratedMutation<
  APITypes.CreateDecklineMutationVariables,
  APITypes.CreateDecklineMutation
>;
export const createDeckColumn = /* GraphQL */ `mutation CreateDeckColumn(
  $userAlias: String!
  $request: CreateDeckColumnInput!
) {
  createDeckColumn(userAlias: $userAlias, request: $request) {
    pk
    sk
    deckColumnGSI_pk
    deckColumnGSI_sk
    deck_id
    column_template
    page_section
    column_no
    column_title
    column_name
    no_of_columns
    column_description
    scenario_display_name
    scenario_period
    block_id
    comparison_scenario
    comparison_scenario_period
    fx_scenario
    fx_scenario_period
    denominator_scenario
    denominator_scenario_period
    block_header
    non_material_flag
    denominator_kpi_exception_flag
    last_updated_date
    column_mapping_group
    report_header
    time_grain
    deck_cycle
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDeckColumnMutationVariables,
  APITypes.CreateDeckColumnMutation
>;
export const createKPI = /* GraphQL */ `mutation CreateKPI($userAlias: String!, $request: CreateKPIInput!) {
  createKPI(userAlias: $userAlias, request: $request) {
    pk
    sk
    is_calculated_kpi
    kpi_type
    kpi_formula
    kpi_map {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    last_updated_date
    __typename
  }
}` as GeneratedMutation<
  APITypes.CreateKPIMutationVariables,
  APITypes.CreateKPIMutation
>;
export const createFootnote = /* GraphQL */ `mutation CreateFootnote($userAlias: String!, $request: CreateFootnoteInput!) {
  createFootnote(userAlias: $userAlias, request: $request) {
    pk
    sk
    footnote_no
    footnote_description
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFootnoteMutationVariables,
  APITypes.CreateFootnoteMutation
>;
export const saveDeck = /* GraphQL */ `mutation SaveDeck($userAlias: String, $request: SaveDeckInput!) {
  saveDeck(userAlias: $userAlias, request: $request)
}
` as GeneratedMutation<
  APITypes.SaveDeckMutationVariables,
  APITypes.SaveDeckMutation
>;
export const publishDeck = /* GraphQL */ `mutation PublishDeck($userAlias: String, $request: PublishDeckInput!) {
  publishDeck(userAlias: $userAlias, request: $request)
}
` as GeneratedMutation<
  APITypes.PublishDeckMutationVariables,
  APITypes.PublishDeckMutation
>;
export const updateDeck = /* GraphQL */ `mutation UpdateDeck($userAlias: String!, $request: UpdateDeckInput!) {
  updateDeck(userAlias: $userAlias, request: $request) {
    pk
    sk
    deckGSI_pk
    deckGSI_sk
    deck_name
    created_date
    last_updated_date
    created_by
    last_updated_by
    current_user
    locked_by
    locked_at
    lock_expiry
    publish_status
    publish_user
    publish_deck_cycle
    has_active_system_run
    last_publish_date
    publish_timestamp
    deck_cycle
    enabled_page_grains
    enabled_datasets
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDeckMutationVariables,
  APITypes.UpdateDeckMutation
>;
export const updateSystemRunStatus = /* GraphQL */ `mutation UpdateSystemRunStatus(
  $userAlias: String!
  $has_active_system_run: Boolean!
) {
  updateSystemRunStatus(
    userAlias: $userAlias
    has_active_system_run: $has_active_system_run
  )
}
` as GeneratedMutation<
  APITypes.UpdateSystemRunStatusMutationVariables,
  APITypes.UpdateSystemRunStatusMutation
>;
export const lockDeck = /* GraphQL */ `mutation LockDeck($deck_id: String!, $userAlias: String) {
  lockDeck(deck_id: $deck_id, userAlias: $userAlias) {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LockDeckMutationVariables,
  APITypes.LockDeckMutation
>;
export const releaseDeckLock = /* GraphQL */ `mutation ReleaseDeckLock(
  $deck_id: String!
  $userAlias: String
  $expected_schedule_name: String
) {
  releaseDeckLock(
    deck_id: $deck_id
    userAlias: $userAlias
    expected_schedule_name: $expected_schedule_name
  ) {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReleaseDeckLockMutationVariables,
  APITypes.ReleaseDeckLockMutation
>;
export const lockPage = /* GraphQL */ `mutation LockPage($deck_id: String!, $page_name: String!, $userAlias: String) {
  lockPage(deck_id: $deck_id, page_name: $page_name, userAlias: $userAlias) {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LockPageMutationVariables,
  APITypes.LockPageMutation
>;
export const releasePageLock = /* GraphQL */ `mutation ReleasePageLock(
  $deck_id: String!
  $page_name: String!
  $userAlias: String
  $expected_schedule_name: String
) {
  releasePageLock(
    deck_id: $deck_id
    page_name: $page_name
    userAlias: $userAlias
    expected_schedule_name: $expected_schedule_name
  ) {
    deck_id
    page_name
    locked_by
    locked_at
    lock_expiry
    lock_scope
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReleasePageLockMutationVariables,
  APITypes.ReleasePageLockMutation
>;
export const createRootKPI = /* GraphQL */ `mutation CreateRootKPI($userAlias: String, $request: CreateRootKPIInput!) {
  createRootKPI(userAlias: $userAlias, request: $request) {
    pk
    sk
    root_kpi_id
    root_kpi_name
    kpi_type
    variants {
      pk
      sk
      kpi_variant_id
      variant_name
      variant_overrides {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      dataset_source
      kpi_type
      root_kpi_id
      created_date
      last_updated_date
      created_by
      last_updated_by
      __typename
    }
    created_date
    created_by
    last_updated_date
    last_updated_by
    __typename
  }
}` as GeneratedMutation<
  APITypes.CreateRootKPIMutationVariables,
  APITypes.CreateRootKPIMutation
>;
export const updateRootKPI = /* GraphQL */ `mutation UpdateRootKPI($userAlias: String, $request: UpdateRootKPIInput!) {
  updateRootKPI(userAlias: $userAlias, request: $request) {
    pk
    sk
    root_kpi_id
    root_kpi_name
    kpi_type
    variants {
      pk
      sk
      kpi_variant_id
      variant_name
      variant_overrides {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      dataset_source
      kpi_type
      root_kpi_id
      created_date
      last_updated_date
      created_by
      last_updated_by
      __typename
    }
    created_date
    created_by
    last_updated_date
    last_updated_by
    __typename
  }
}` as GeneratedMutation<
  APITypes.UpdateRootKPIMutationVariables,
  APITypes.UpdateRootKPIMutation
>;
export const deleteRootKPI = /* GraphQL */ `mutation DeleteRootKPI($userAlias: String, $root_kpi_id: String!) {
  deleteRootKPI(userAlias: $userAlias, root_kpi_id: $root_kpi_id)
}
` as GeneratedMutation<
  APITypes.DeleteRootKPIMutationVariables,
  APITypes.DeleteRootKPIMutation
>;
export const createKPIVariant = /* GraphQL */ `mutation CreateKPIVariant($userAlias: String, $request: CreateKPIVariantInput!) {
  createKPIVariant(userAlias: $userAlias, request: $request) {
    pk
    sk
    kpi_variant_id
    variant_name
    variant_overrides {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    dataset_source
    kpi_type
    root_kpi_id
    created_date
    last_updated_date
    created_by
    last_updated_by
    __typename
  }
}` as GeneratedMutation<
  APITypes.CreateKPIVariantMutationVariables,
  APITypes.CreateKPIVariantMutation
>;
export const updateKPIVariant = /* GraphQL */ `mutation UpdateKPIVariant($userAlias: String, $request: UpdateKPIVariantInput!) {
  updateKPIVariant(userAlias: $userAlias, request: $request) {
    pk
    sk
    kpi_variant_id
    variant_name
    variant_overrides {
      datasetSource
      company_hierarchy
      company
      costcenter_hierarchy
      costcenter
      costtype
      fieldtype
      location_hierarchy
      location
      ... on GalaxyKPIDrivers {
        account_hierarchy
        account
        project_hierarchy
        project
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costpool
      }
      ... on HctrKPIDrivers {
        measure_hierarchy
        measure
        transferDirection_hierarchy
        transferDirection
        workflow_hierarchy
        workflow
      }
      __typename
    }
    dataset_source
    kpi_type
    root_kpi_id
    created_date
    last_updated_date
    created_by
    last_updated_by
    affected_page_ids
    updated_decklines {
      calc_members {
        dimension
        tokens {
          kind
          value
          __typename
        }
        pins {
          dimension
          node
          __typename
        }
        __typename
      }
      pk
      sk
      page_name
      kpi_id
      kpi_id_by_override {
        override_set {
          datasetSource
          account_hierarchy
          account
          location_hierarchy
          location
          project_hierarchy
          project
          company_hierarchy
          company
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costcenter_hierarchy
          costcenter
          costtype
          costpool
          fieldtype
          __typename
        }
        kpi_id
        __typename
      }
      kpi_name
      kpi_formula
      serial_no
      is_code_or_description
      is_format_bold
      is_format_italics
      is_format_underline
      format_text_color
      format_cell_color
      format_cell_default
      format_cell_overrides {
        colKey
        format
        __typename
      }
      blankline_type
      is_format_borderline
      footnotes
      subtotal_formula
      subtotal_parent
      is_calculated_kpi
      kpi_type
      deckline_kind
      deckline_drivers {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      is_exception
      page_section
      column_template
      adjcalcflag
      exceptioncalculatedkpiflag
      bordertopflag
      borderrightflag
      borderbottomflag
      borderleftflag
      borderweightflag
      textunderlineflag
      denominator_kpi_id_for_pct
      denominator_kpi_id_drivers {
        datasetSource
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        fieldtype
        __typename
      }
      denominator_is_calculated_kpi
      denominator_kpi_formula
      root_kpi_id
      kpi_variant_id
      display_name
      denominator_kpi_variant_id
      measure
      kpi_name_indent_level
      fxinclflag
      calcdivisionflag
      bps_override_flag
      comments {
        commentId
        user
        commentDesc
        timestamp
        __typename
      }
      __typename
    }
    __typename
  }
}` as GeneratedMutation<
  APITypes.UpdateKPIVariantMutationVariables,
  APITypes.UpdateKPIVariantMutation
>;
export const deleteKPIVariant = /* GraphQL */ `mutation DeleteKPIVariant($userAlias: String, $request: DeleteKPIVariantInput!) {
  deleteKPIVariant(userAlias: $userAlias, request: $request) {
    kpi_variant_id
    root_kpi_id
    root_kpi_auto_deleted
    affected_page_ids
    deleted_decklines {
      calc_members {
        dimension
        tokens {
          kind
          value
          __typename
        }
        pins {
          dimension
          node
          __typename
        }
        __typename
      }
      pk
      sk
      page_name
      kpi_id
      kpi_id_by_override {
        override_set {
          datasetSource
          account_hierarchy
          account
          location_hierarchy
          location
          project_hierarchy
          project
          company_hierarchy
          company
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costcenter_hierarchy
          costcenter
          costtype
          costpool
          fieldtype
          __typename
        }
        kpi_id
        __typename
      }
      kpi_name
      kpi_formula
      serial_no
      is_code_or_description
      is_format_bold
      is_format_italics
      is_format_underline
      format_text_color
      format_cell_color
      format_cell_default
      format_cell_overrides {
        colKey
        format
        __typename
      }
      blankline_type
      is_format_borderline
      footnotes
      subtotal_formula
      subtotal_parent
      is_calculated_kpi
      kpi_type
      deckline_kind
      deckline_drivers {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      is_exception
      page_section
      column_template
      adjcalcflag
      exceptioncalculatedkpiflag
      bordertopflag
      borderrightflag
      borderbottomflag
      borderleftflag
      borderweightflag
      textunderlineflag
      denominator_kpi_id_for_pct
      denominator_kpi_id_drivers {
        datasetSource
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        fieldtype
        __typename
      }
      denominator_is_calculated_kpi
      denominator_kpi_formula
      root_kpi_id
      kpi_variant_id
      display_name
      denominator_kpi_variant_id
      measure
      kpi_name_indent_level
      fxinclflag
      calcdivisionflag
      bps_override_flag
      comments {
        commentId
        user
        commentDesc
        timestamp
        __typename
      }
      __typename
    }
    reordered_decklines {
      calc_members {
        dimension
        tokens {
          kind
          value
          __typename
        }
        pins {
          dimension
          node
          __typename
        }
        __typename
      }
      pk
      sk
      page_name
      kpi_id
      kpi_id_by_override {
        override_set {
          datasetSource
          account_hierarchy
          account
          location_hierarchy
          location
          project_hierarchy
          project
          company_hierarchy
          company
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costcenter_hierarchy
          costcenter
          costtype
          costpool
          fieldtype
          __typename
        }
        kpi_id
        __typename
      }
      kpi_name
      kpi_formula
      serial_no
      is_code_or_description
      is_format_bold
      is_format_italics
      is_format_underline
      format_text_color
      format_cell_color
      format_cell_default
      format_cell_overrides {
        colKey
        format
        __typename
      }
      blankline_type
      is_format_borderline
      footnotes
      subtotal_formula
      subtotal_parent
      is_calculated_kpi
      kpi_type
      deckline_kind
      deckline_drivers {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      is_exception
      page_section
      column_template
      adjcalcflag
      exceptioncalculatedkpiflag
      bordertopflag
      borderrightflag
      borderbottomflag
      borderleftflag
      borderweightflag
      textunderlineflag
      denominator_kpi_id_for_pct
      denominator_kpi_id_drivers {
        datasetSource
        account_hierarchy
        account
        location_hierarchy
        location
        project_hierarchy
        project
        company_hierarchy
        company
        product_hierarchy
        product
        revgp_hierarchy
        revgp
        datasource_hierarchy
        datasource
        channel_hierarchy
        channel
        costcenter_hierarchy
        costcenter
        costtype
        costpool
        fieldtype
        __typename
      }
      denominator_is_calculated_kpi
      denominator_kpi_formula
      root_kpi_id
      kpi_variant_id
      display_name
      denominator_kpi_variant_id
      measure
      kpi_name_indent_level
      fxinclflag
      calcdivisionflag
      bps_override_flag
      comments {
        commentId
        user
        commentDesc
        timestamp
        __typename
      }
      __typename
    }
    __typename
  }
}` as GeneratedMutation<
  APITypes.DeleteKPIVariantMutationVariables,
  APITypes.DeleteKPIVariantMutation
>;
export const saveColumnTemplate = /* GraphQL */ `mutation SaveColumnTemplate($userAlias: String, $request: SaveColumnTemplateInput!) {
  saveColumnTemplate(userAlias: $userAlias, request: $request) {
    pk
    sk
    deckColumnGSI_pk
    deckColumnGSI_sk
    deck_id
    layout_family
    deck_cycle
    grain
    name
    header_tree {
      ... on SectionNode {
        nodeId
        kind
        label
        footnotes
        children {
          ... on GroupNode {
            nodeId
            kind
            label
            footnotes
            children {
              nodeId
              kind
              label
              footnotes
              blockId
              measure
              scenario
              periodToken
              timeGrain
              nonMaterial
              dimensionOverrides {
                datasetSource
                account_hierarchy
                account
                location_hierarchy
                location
                project_hierarchy
                project
                company_hierarchy
                company
                product_hierarchy
                product
                revgp_hierarchy
                revgp
                datasource_hierarchy
                datasource
                channel_hierarchy
                channel
                costcenter_hierarchy
                costcenter
                costtype
                costpool
                fieldtype
                __typename
              }
              datasetSource
              resolvedScenario
              resolvedPeriod
              scenarioPlacement
              periodPlacement
              periodOwnedByLeaves
              bandPeriod
              children {
                nodeId
                kind
                label
                footnotes
                columnNo
                measure
                scenario
                periodToken
                timeGrain
                dimensionOverrides {
                  datasetSource
                  account_hierarchy
                  account
                  location_hierarchy
                  location
                  project_hierarchy
                  project
                  company_hierarchy
                  company
                  product_hierarchy
                  product
                  revgp_hierarchy
                  revgp
                  datasource_hierarchy
                  datasource
                  channel_hierarchy
                  channel
                  costcenter_hierarchy
                  costcenter
                  costtype
                  costpool
                  fieldtype
                  __typename
                }
                format {
                  cellDefault
                  __typename
                }
                calculation {
                  type
                  operands
                  __typename
                }
                colKey
                excelLetter
                resolvedScenario
                resolvedPeriod
                __typename
              }
              __typename
            }
            __typename
          }
          ... on BlockNode {
            nodeId
            kind
            label
            footnotes
            blockId
            measure
            scenario
            periodToken
            timeGrain
            nonMaterial
            dimensionOverrides {
              datasetSource
              account_hierarchy
              account
              location_hierarchy
              location
              project_hierarchy
              project
              company_hierarchy
              company
              product_hierarchy
              product
              revgp_hierarchy
              revgp
              datasource_hierarchy
              datasource
              channel_hierarchy
              channel
              costcenter_hierarchy
              costcenter
              costtype
              costpool
              fieldtype
              __typename
            }
            datasetSource
            resolvedScenario
            resolvedPeriod
            scenarioPlacement
            periodPlacement
            periodOwnedByLeaves
            bandPeriod
            children {
              nodeId
              kind
              label
              footnotes
              columnNo
              measure
              scenario
              periodToken
              timeGrain
              dimensionOverrides {
                datasetSource
                account_hierarchy
                account
                location_hierarchy
                location
                project_hierarchy
                project
                company_hierarchy
                company
                product_hierarchy
                product
                revgp_hierarchy
                revgp
                datasource_hierarchy
                datasource
                channel_hierarchy
                channel
                costcenter_hierarchy
                costcenter
                costtype
                costpool
                fieldtype
                __typename
              }
              format {
                cellDefault
                __typename
              }
              calculation {
                type
                operands
                __typename
              }
              colKey
              excelLetter
              resolvedScenario
              resolvedPeriod
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      ... on GroupNode {
        nodeId
        kind
        label
        footnotes
        children {
          nodeId
          kind
          label
          footnotes
          blockId
          measure
          scenario
          periodToken
          timeGrain
          nonMaterial
          dimensionOverrides {
            datasetSource
            account_hierarchy
            account
            location_hierarchy
            location
            project_hierarchy
            project
            company_hierarchy
            company
            product_hierarchy
            product
            revgp_hierarchy
            revgp
            datasource_hierarchy
            datasource
            channel_hierarchy
            channel
            costcenter_hierarchy
            costcenter
            costtype
            costpool
            fieldtype
            __typename
          }
          datasetSource
          resolvedScenario
          resolvedPeriod
          scenarioPlacement
          periodPlacement
          periodOwnedByLeaves
          bandPeriod
          children {
            nodeId
            kind
            label
            footnotes
            columnNo
            measure
            scenario
            periodToken
            timeGrain
            dimensionOverrides {
              datasetSource
              account_hierarchy
              account
              location_hierarchy
              location
              project_hierarchy
              project
              company_hierarchy
              company
              product_hierarchy
              product
              revgp_hierarchy
              revgp
              datasource_hierarchy
              datasource
              channel_hierarchy
              channel
              costcenter_hierarchy
              costcenter
              costtype
              costpool
              fieldtype
              __typename
            }
            format {
              cellDefault
              __typename
            }
            calculation {
              type
              operands
              __typename
            }
            colKey
            excelLetter
            resolvedScenario
            resolvedPeriod
            __typename
          }
          __typename
        }
        __typename
      }
      ... on BlockNode {
        nodeId
        kind
        label
        footnotes
        blockId
        measure
        scenario
        periodToken
        timeGrain
        nonMaterial
        dimensionOverrides {
          datasetSource
          account_hierarchy
          account
          location_hierarchy
          location
          project_hierarchy
          project
          company_hierarchy
          company
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costcenter_hierarchy
          costcenter
          costtype
          costpool
          fieldtype
          __typename
        }
        datasetSource
        resolvedScenario
        resolvedPeriod
        scenarioPlacement
        periodPlacement
        periodOwnedByLeaves
        bandPeriod
        children {
          nodeId
          kind
          label
          footnotes
          columnNo
          measure
          scenario
          periodToken
          timeGrain
          dimensionOverrides {
            datasetSource
            account_hierarchy
            account
            location_hierarchy
            location
            project_hierarchy
            project
            company_hierarchy
            company
            product_hierarchy
            product
            revgp_hierarchy
            revgp
            datasource_hierarchy
            datasource
            channel_hierarchy
            channel
            costcenter_hierarchy
            costcenter
            costtype
            costpool
            fieldtype
            __typename
          }
          format {
            cellDefault
            __typename
          }
          calculation {
            type
            operands
            __typename
          }
          colKey
          excelLetter
          resolvedScenario
          resolvedPeriod
          __typename
        }
        __typename
      }
      __typename
    }
    template_version
    created_by
    created_date
    last_updated_by
    last_updated_date
    __typename
  }
}` as GeneratedMutation<
  APITypes.SaveColumnTemplateMutationVariables,
  APITypes.SaveColumnTemplateMutation
>;
export const saveCalcDefinition = /* GraphQL */ `mutation SaveCalcDefinition($userAlias: String, $request: SaveCalcDefinitionInput!) {
  saveCalcDefinition(userAlias: $userAlias, request: $request) {
    pk
    sk
    deck_id
    stem_kpi_id
    kpi_formula_template
    kpi_operands {
      ref
      kind
      overrides {
        datasetSource
        company_hierarchy
        company
        costcenter_hierarchy
        costcenter
        costtype
        fieldtype
        location_hierarchy
        location
        ... on GalaxyKPIDrivers {
          account_hierarchy
          account
          project_hierarchy
          project
          product_hierarchy
          product
          revgp_hierarchy
          revgp
          datasource_hierarchy
          datasource
          channel_hierarchy
          channel
          costpool
        }
        ... on HctrKPIDrivers {
          measure_hierarchy
          measure
          transferDirection_hierarchy
          transferDirection
          workflow_hierarchy
          workflow
        }
        __typename
      }
      deckline_id
      root_kpi_id
      kpi_variant_id
      kpi_id
      __typename
    }
    dataset_source
    last_updated_by
    last_updated_date
    __typename
  }
}` as GeneratedMutation<
  APITypes.SaveCalcDefinitionMutationVariables,
  APITypes.SaveCalcDefinitionMutation
>;
